package core.io.dto

import kotlinx.serialization.SerialName

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 06.04.23
 * Author : mariorosshirt
 */
@kotlinx.serialization.Serializable
data class JSBridgeRGBColourDTO(
 @SerialName("R")
 val mR: String,

 @SerialName("G")
 val mG: String,

 @SerialName("B")
 val mB: String,

 @SerialName("unique")
 val mUnique: String
)
